import {getBundleSetInfo, isBundleSet} from './bundle-utils'
import {isProductPurchasable} from './product-utils'

export const getProductSchemaAvailability = (product) => {
    if (!isProductPurchasable(product)) {
        return 'https://schema.org/Discontinued'
    }

    // Bundle product sets expose aggregate availability in their bundle data, not inventory.
    const orderable = isBundleSet(product)
        ? getBundleSetInfo(product)?.orderable
        : product?.inventory?.orderable

    return !orderable || orderable === 'false'
        ? 'https://schema.org/OutOfStock'
        : 'https://schema.org/InStock'
}
